import { useEffect } from "react";
import { registerLocale } from "react-datepicker";
import uk from "date-fns/locale/uk";
import SearchArhivImage from "../components/SearchArhivImage";

registerLocale("uk", uk);

const ScheduleArhiv = () => {

    useEffect(()=>{
        window.scrollTo(0,0);
      }, [])

    return (
        <section className="power-off">
            <div className="container">
                {/* тут можем дати глобальний заголовок під архіви зображень, поки пусто */}
                <SearchArhivImage />
            </div>
        </section> 
    )
}

export default ScheduleArhiv